import { Component, OnInit, OnDestroy } from '@angular/core';
import { Resolution } from 'src/app/shared/models/resolution.model';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ResolutionAssignListService } from './resolution-assign-list.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResolutionCreateModalComponent } from '../resolution-create-modal/resolution-create-modal.component';
import Swal from 'sweetalert2';
import { Stock } from 'src/app/shared/models/stock.model';
import { Purpose } from 'src/app/shared/models/purpose.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Response } from 'src/app/shared/models/response.model';
import { ResolutionAsignModalComponent } from '../resolution-asign-modal/resolution-asign-modal.component';

@Component({
  selector: 'app-resolution-assign-list',
  templateUrl: './resolution-assign-list.component.html',
  styleUrls: ['./resolution-assign-list.component.scss']
})
export class ResolutionAssignListComponent implements OnInit, OnDestroy {

  resolutions: Resolution[];
  modalOptions: NgbModalOptions;
  stocks: Stock[];
  purposes: Purpose[];
  filterForm: FormGroup;

  paginationOffset: number;
  paginationLimit : number;
  paginationTotal : number;
  paginationMaxPageSize: number;
  searchFilter: string;

  private getAllSubscription: Subscription = null;
  private deleteSubscription: Subscription = null;
  private createSubscription: Subscription = null;
  private editSubscription: Subscription = null;
  private assignSubscription: Subscription = null;
  private stocksSubscription: Subscription = null;
  private purposesSubscription: Subscription = null;

  constructor(private resolutionListService: ResolutionAssignListService,
              private modalService: NgbModal,
              private spinner: NgxSpinnerService,
              private formBuilder: FormBuilder,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.paginationOffset      = 1;
    this.paginationLimit       = 10;
    this.paginationTotal       = 0;
    this.paginationMaxPageSize = 5;
    this.searchFilter          = '';

    this.resolutions = [];
    this.stocks      = [];
    this.purposes    = [];
    this.filterForm = this.formBuilder.group({
      stock_id   : [''],
      purpose_id : ['']
    });

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg',
    };

    this.getStocks();
    this.getPurposes();
  }

  ngOnDestroy(): void {
    if (this.getAllSubscription   !== null) { this.getAllSubscription.unsubscribe(); }
    if (this.deleteSubscription   !== null) { this.deleteSubscription.unsubscribe(); }
    if (this.createSubscription   !== null) { this.createSubscription.unsubscribe(); }
    if (this.editSubscription     !== null) { this.editSubscription.unsubscribe(); }
    if (this.stocksSubscription   !== null) { this.stocksSubscription.unsubscribe(); }
    if (this.purposesSubscription !== null) { this.purposesSubscription.unsubscribe(); }
    if (this.assignSubscription   !== null) { this.assignSubscription.unsubscribe(); }
  }

  /**
   * Get stock list
   */
  getResolutions() {
    
    const stockId   = this.filterForm.get('stock_id').value;
    const purposeId = this.filterForm.get('purpose_id').value;

    if(stockId && purposeId) {

      this.spinner.show();

      this.getAllSubscription = this.resolutionListService.resolveResolutions(stockId, purposeId, this.searchFilter, this.paginationOffset, this.paginationLimit).subscribe((result: Response) => {
        this.resolutions = result.items;
        this.paginationTotal = result.total;

        this.spinner.hide();
      }, (error) => {
        this.spinner.hide();
        this.toastr.error(error);
        console.error(error);
      });

    }
  }

  /**
   *
   */
  getStocks() {
    this.spinner.show();
    this.stocksSubscription = this.resolutionListService.getStocks().subscribe((result: Stock[]) => {
      this.stocks = result;
      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      console.error(error.message);
    });
  }

  /**
   * 
   */
  onStockChange() {
    this.getResolutions();
  }

  /**
   *
   */
  getPurposes() {
    this.spinner.show();
    this.purposesSubscription = this.resolutionListService.getPurposes().subscribe((result: Purpose[]) => {
      this.purposes = result;
      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      console.error(error.message);
    });
  }

  /**
   * 
   */
  onPurposeChange() {
    this.getResolutions();
  }

/**
   *
   */
  onAssign(): void {
    const stockId   = this.filterForm.get('stock_id').value;
    const purposeId = this.filterForm.get('purpose_id').value;

    const modalRef = this.modalService.open(ResolutionAsignModalComponent, this.modalOptions);
    modalRef.componentInstance.currentStockId   = stockId;
    modalRef.componentInstance.currentPurposeId = purposeId;
    modalRef.result.then((data) => {

      // Se vincula el registro
      this.spinner.show();
      this.assignSubscription = this.resolutionListService.assign(data.stock_id, data.purpose_id, data.resolution_id).subscribe((result: any) => {
        this.spinner.hide();
        this.getResolutions();
      }, (error) => {
        this.spinner.hide();
        this.toastr.error(error);
      });
     
    }, (reason) => { });
  }

  /**
   *
   */
  onCreate(): void {
    const modalRef = this.modalService.open(ResolutionCreateModalComponent, this.modalOptions);
    modalRef.result.then((data) => {

      // Se crea el registro
      this.spinner.show();
      this.createSubscription = this.resolutionListService.create(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getResolutions();
      }, (error) => {
        this.spinner.hide();
        this.toastr.error(error);
        console.error('Error in resolution created', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param resolution
   */
  onEdit(resolution: Resolution): void {
    const modalRef = this.modalService.open(ResolutionCreateModalComponent, this.modalOptions);
    modalRef.componentInstance.resolution = resolution;
    modalRef.result.then((data) => {

      this.spinner.show();
      this.editSubscription = this.resolutionListService.update(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getResolutions();
      },
      (error) => {
        this.spinner.hide();
        this.toastr.error(error);
        console.error('Error in resolution modify', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param id
   * @param index
   */
  onDelete(id: number, index: number): void {
    Swal.fire({
      title: '¿Seguro que desea eliminar?',
      text: '¡No podrás recuperar el registro seleccionado!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, Bórralo!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.deleteSubscription = this.resolutionListService.delete(id).subscribe(r => {
          this.resolutions.splice(index, 1);
          this.spinner.hide();
          Swal.fire('Eliminado!', 'El registro ha sido eliminado.', 'success');
        },
        (error) => {
          this.spinner.hide();
          this.toastr.error(error);
          console.error('error to delete item', error);
        });
      }
    });
  }

  /**
   * 
   * @param term 
   */
  onSearch(term: string) {
    this.searchFilter = term;
    this.getResolutions();
  }

  /**
   * 
   */
  onPageChange() {
    this.getResolutions();
  }
}
